export default __webpack_public_path__ + "static/media/leran-background-ellipse.3aac424e.svg";